import { TDisplayDefinitionMap } from '@internal/utils/displayDefinition/TDisplayDefinitionMap'
import { TDisplayDefinitionEntryBoolean } from '@internal/utils/displayDefinition/entry/DisplayDefinitionEntryBoolean'
import { TDisplayDefinitionEntryNumber } from '@internal/utils/displayDefinition/entry/DisplayDefinitionEntryNumber'
import { DisplayDefinitionEntryType } from '@internal/utils/displayDefinition/entry/DisplayDefinitionEntryType'
import { MachineAttribute } from '@internal/utils/machine/MachineAttribute'
import { TFiltersConfiguration } from './TFiltersConfiguration'

export const defaultSearchFilters: TFiltersConfiguration = {
  rangeFilters: [
    {
      type: DisplayDefinitionEntryType.Number,
      label: '', // label gets generated in the filter component
      machineAttribute: MachineAttribute.PRICE_NET_EUR,
    },
    {
      type: DisplayDefinitionEntryType.Number,
      label: '', // label gets generated in the filter component
      machineAttribute: MachineAttribute.YEAR_OF_PRODUCTION,
    },
  ],
  features: [],
}

const excludeAttributes: MachineAttribute[] = [
  ...defaultSearchFilters.rangeFilters.map((filter) => filter.machineAttribute),
  MachineAttribute.PRICE_NET,
]

export const displayDefinitionToSearchFiltersConfiguration = (
  displayDefinitions: TDisplayDefinitionMap
): TFiltersConfiguration => {
  const filters: TFiltersConfiguration = {
    ...defaultSearchFilters,
  }

  const displayDefinition = displayDefinitions.WEBSITE_SERP_FILTERS

  if (displayDefinition?.categories?.length) {
    const category = displayDefinition.categories[0]

    const qmsRangeFilters = category.entries.reduce<
      TDisplayDefinitionEntryNumber[]
    >((list, entry) => {
      if (
        !excludeAttributes.includes(entry.machineAttribute) &&
        entry.type === DisplayDefinitionEntryType.Number
      ) {
        list.push(entry)
      }

      return list
    }, [])

    filters.rangeFilters = [
      ...defaultSearchFilters.rangeFilters,
      ...qmsRangeFilters,
    ]
    filters.features = [
      ...defaultSearchFilters.features,
      ...category.entries.filter(
        (entry): entry is TDisplayDefinitionEntryBoolean =>
          entry.type === DisplayDefinitionEntryType.Boolean
      ),
    ]
  }

  return filters
}
